module.exports = __webpack_public_path__ + "img/amex.6440abe0.png";